import { JobListResponse } from '@doda/api-client/aspida/@types';
import { createSlice } from '@reduxjs/toolkit';

/**
 * 初期表示求人一覧
 * @param requirements 募集・採用情報
 * @param income 年収
 * @param workplaceEnvironment 会社・職場
 * @param holidayAndWayOfWorking 休日・働き方
 * @param employeeAverageAge 社員の平均年齢
 * @param employmentStatus 雇用形態
 * @param welfareBenefits 福利厚生
 * @param positionsAndLanguageSkills 仕事内容・語学
 * @param establish 設立年数
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobTrendRecommendListState {
  requirements: JobListResponse | undefined;
  income: JobListResponse | undefined;
  workplaceEnvironment: JobListResponse | undefined;
  holidayAndWayOfWorking: JobListResponse | undefined;
  employeeAverageAge: JobListResponse | undefined;
  employmentStatus: JobListResponse | undefined;
  welfareBenefits: JobListResponse | undefined;
  positionsAndLanguageSkills: JobListResponse | undefined;
  establish: JobListResponse | undefined;
}

// 初期状態
export const jobTrendRecommendListInitialState: JobTrendRecommendListState = {
  requirements: undefined,
  income: undefined,
  workplaceEnvironment: undefined,
  holidayAndWayOfWorking: undefined,
  employeeAverageAge: undefined,
  employmentStatus: undefined,
  welfareBenefits: undefined,
  positionsAndLanguageSkills: undefined,
  establish: undefined,
};

/**
 * State型
 * @param jobTrendRecommendList カテゴリごとの初期表示求人一覧
 */
export interface JobTrendRecommendListSliceState {
  jobTrendRecommendList: ReturnType<typeof jobTrendRecommendListReducer>;
}

const jobTrendRecommendListSlice = createSlice({
  name: 'jobTrendRecommendList',
  initialState: jobTrendRecommendListInitialState,
  reducers: {
    setRequirementsList: (state, action) => {
      state.requirements = action.payload;
    },
    setIncomeList: (state, action) => {
      state.income = action.payload;
    },
    setWorkplaceEnvironmentList: (state, action) => {
      state.workplaceEnvironment = action.payload;
    },
    setHolidayAndWayOfWorkingList: (state, action) => {
      state.holidayAndWayOfWorking = action.payload;
    },
    setEmployeeAverageAgeList: (state, action) => {
      state.employeeAverageAge = action.payload;
    },
    setEmploymentStatusList: (state, action) => {
      state.employmentStatus = action.payload;
    },
    setWelfareBenefitsList: (state, action) => {
      state.welfareBenefits = action.payload;
    },
    setPositionsAndLanguageSkillsList: (state, action) => {
      state.positionsAndLanguageSkills = action.payload;
    },
    setEstablishList: (state, action) => {
      state.establish = action.payload;
    },
  },
});

// Create Action
export const {
  setRequirementsList,
  setIncomeList,
  setWorkplaceEnvironmentList,
  setHolidayAndWayOfWorkingList,
  setEmployeeAverageAgeList,
  setEmploymentStatusList,
  setWelfareBenefitsList,
  setPositionsAndLanguageSkillsList,
  setEstablishList,
} = jobTrendRecommendListSlice.actions;

// reducer
export const jobTrendRecommendListReducer = jobTrendRecommendListSlice.reducer;

/**
 * selector
 * @param state
 * @returns 初期表示求人一覧
 */
export const jobTrendRecommendListSelector = (state) =>
  state.jobTrendRecommendList;
